<template>
  <div>
    <nav class="breadcrumb-dark">
      <ul class="breadcrumb-dark__list">
        <li class="breadcrumb-dark__level">
          <router-link to="/" class="breadcrumb-dark__link" active-class="breadcrumb-dark__link--active">Choose a format</router-link>
        </li>

        <li class="breadcrumb-dark__level">
          <span data-v-config-step="0" data-v-long-step="7" class="breadcrumb-dark__link">Configuration</span>
        </li>
      </ul>
        <SeriesBadge v-if='format.id' :series="format.series" :box="false" class="series-center"/>
      <div class="breadcrumb-dark__select-preview select-preview" v-if="sidebarActive" data-v-config-step="4">
        <label class="select-preview__label">Display size</label>
        <size-input selectClass="select-preview__select" v-model="settings['size']" :defaultValue="settings['size']" :options="sizeItem().options" v-if="sizeItem()"/>
      </div>
      <!--<ul class="breadcrumb-dark__drawer drawer">
        <li class="drawer__item drawer__item&#45;&#45;bottom" @click="sidebarActive = !sidebarActive" v-bind:class="{'drawer__item&#45;&#45;active': !sidebarActive}">bottom</li>
        <li class="drawer__item drawer__item&#45;&#45;left" @click="sidebarActive = !sidebarActive" v-bind:class="{'drawer__item&#45;&#45;active': sidebarActive}">left</li>
      </ul>-->
    </nav>
    <section class="main-content main-content--white-background" v-bind:class="{'main-content--full-width': sidebarActive}">

      <section class="main-content__full section section--configuration" v-if="!sidebarActive">
        <header class="section__header">
          <h1 class="section__title">New creative</h1>
          <div class="section__header__area">
            <a href="#" v-on:click="save" class="section__header__button button button--secondary button--ghost" v-bind:class="{ 'button--disabled': !settings.name || (settings.name && settings.name.length < 3) }">Save</a>
            <a href="#" v-if="!getShareCode() && !isAppStandalone()" v-on:click="save" class="section__header__button button button--primary" v-bind:class="{ 'button--disabled': !settings.name || (settings.name && settings.name.length < 3) }">Save and Insert</a>
          </div>
        </header>
      </section>

      <section class="main-content__full section" v-bind:class="{'section--sidebar': sidebarActive}">
        <form data-v-config-step="1" data-v-long-step="8" class="section__content section__content--form form">

          <fieldset class="form__group" data-v-config-step="2">

            <article class="form__item">
              <label class="form__item__label">
                <h1 class="form__item__name">Advertisement format</h1>
                <small class="form__item__description">This is the format chosen for this adverisement. This cannot be changed.</small>
              </label>

              <section class="form__item__input input">
                <input type="text" class="input__field" disabled="disabled" v-model="format.name" />
              </section>
            </article>

            <article class="form__item">
              <label class="form__item__label">
                <h1 class="form__item__name">Advertisement name (Required)</h1>
                <small class="form__item__description">This is a unique name for the advertisement so you can identify it. Minimum 3 characters long.</small>
              </label>

              <section class="form__item__input input">
                <input type="text" class="input__field" v-model="settings.name" v-bind:class="{ 'input--success': settings.name, 'input--error': !settings.name }" />
              </section>
            </article>

            <article class="form__item" v-if="format.updateable">
              <label class="form__item__label">
                <h1 class="form__item__name">Self-Serve</h1>
                <small class="form__item__description">You can make this ad "self-serve" in that readers can update its contents for a period of time (with your approval, of course). If this is enabled, additional options will be made available.</small>
              </label>

              <section class="form__item__input input">
                <button v-if="!isUpdateable" class="button button--primary" @click="makeUpdateable">Enable Self-Serve</button>
                <button v-if="isUpdateable" class="button button--remove update__button--remove" @click="removeUpdateable()">Disable Self-Serve</button>
              </section>
            </article>

            <article v-if="(isUpdateable && field.name != 'link') || !isUpdateable" class="form__item" v-for="(field, index) in configurableFields()">
              <label class="form__item__label">
                <h1 class="form__item__name">{{field.label}}</h1>
                <small class="form__item__description">{{field.description}}</small>
              </label>

              <!--<p>current value: {{settings[field.name]}}</p>-->
              <item :id="getFormName(field.type, index)" v-model="settings[field.name]" :defaultValue="settings[field.name]" :item="field" v-if="!field.array" />
              <array-item :id="getFormName(field.type, index)" v-model="settings[field.name]" :defaultValue="settings[field.name]" :item="field" v-if="field.array" />
            </article>

            <article class="form__item" v-if="isUpdateable">
              <label class="form__item__label">
                <h1 class="form__item__name">Self-Serve Advertisements</h1>
                <small class="form__item__description">These are the fields for a self-serve advertisement.</small>
              </label>

              <div v-if="isUpdateable">
                <div v-for="(field, index) in updateable_fields">
                  <label class="form__item__label">
                    <h1 class="form__item__name">{{ field.label }}</h1>
                    <small class="form__item__description">{{ field.description }}</small>
                  </label>

                  <item @input="updateLocalStorage" :id="getFormName(field.type,index)" v-model="updateable_settings[field.name]" :defaultValue="updateable_settings[field.name]" :item="field"></item>
                </div>
                <article class="form__item">
                  <label class="form__item__label">
                    <h1 class="form__item__name">Create Update Link</h1>
                    <small class="form__item__description">
                      Share this link with your advertisers so they can create self-serve updates after saving this ad.
                      This link will also be auto-filled as the click destination link of this advertisement.
                    </small>
                  </label>

                  <section class="form__item__input input">
                    <input v-if="ad.id" type="text" class="input__field" disabled="disabled" v-model="getSelfServeLink" />
                    <input v-if="!ad.id" type="text" class="input__field" disabled="disabled" value="This link will be displayed here after you create the ad.">
                  </section>
                </article>

              </div>
            </article>
          </fieldset>
        </form>

        <section class="section__content section__content--preview">
          <article class="section__content__preview preview">
            <header class="preview__header" v-if="!sidebarActive">
              <h1 class="preview__title">Preview</h1>
            </header>

            <preview-settings data-v-config-step="3" ref="preview" v-on:preview-data="onPreviewData" :ad="ad" :inputs="settings"></preview-settings>

            <div v-if="!hideWatermark" class="main-content__watermark">
              <p>Remove the watermark <span v-if="isUpdateable">for self serve</span>.</p>
              <div v-if="!isUpdateable" @click.prevent="openPricingModal" class="button button--primary">Upgrade your account.</div>
              <div v-if="isUpdateable" @click.prevent="openReferralModal" class="button button--primary">Refer someone to ParkAve.</div>
            </div>

            <footer class="preview__footer" v-if="!sidebarActive">
              <ul class="preview__details details">
                <li class="details__item">
                  Preview Size: <strong class="details__item__value">{{preview.length}} Bytes</strong>
                </li>

                <li class="details__item details__item--preview detail__item__select-preview">
                  <div class="select-preview select-preview--light select-preview--small">
                    <label class="select-preview__label">Preview size</label>
                    <size-input selectClass="select-preview__select" v-model="settings['size']" :defaultValue="settings['size']" :options="sizeItem().options" v-if="sizeItem()" />
                  </div>

                </li>

                <!--<li class="details__item">
                  Dimension: <strong class="details__item__value">600x388</strong>
                </li>-->

                <!--<li class="details__item details__item--right">
                  <a href="#" class="detail__full-size">View original size</a>
                </li>-->
              </ul>
            </footer>
          </article>

          <hr class="seperator" v-if="!sidebarActive" />

          <footer class="section__footer">
            <ul class="details" v-if="sidebarActive">
              <li class="details__item">
                <span v-if="preview.scale < 100"><strong class="details__item__value">Note:</strong> Scaled down for preview</span>
              </li>
            </ul>

            <a href="#" class="section__footer__button button button--secondary"  v-if="!sidebarActive">Cancel</a>
            <a href="#" v-if="!getShareCode() && !isAppStandalone()" v-on:click="save($event, true)" class="section__footer__button section__footer__button--right button button--primary" v-bind:class="{ 'button--disabled': !settings.name || (settings.name && settings.name.length < 3) }">Save and Insert</a>
            <a href="#" v-on:click="save($event, false)" class="section__footer__button section__footer__button--right button button--primary" v-bind:class="{ 'button--disabled': !settings.name || (settings.name && settings.name.length < 3) }">Save</a>
          </footer>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import store from '../store'
import ArrayItem from './configurator/ArrayItem.vue'
import Item from './configurator/Item.vue'
import SizeInput from './configurator/SizeInput.vue'
import {mapState} from 'vuex'
import responseNotification from '../lib/responseNotification';
import SeriesBadge from '../components/common/SeriesBadge'

import _ from 'lodash'
import { passback } from '../lib/integration';

const configLocalStorageKey = 'parkave_config';

export default {
  name: 'Configuration',
  components: {
    Item,
    ArrayItem,
    SizeInput,
    SeriesBadge
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.me.id) return next();
    store.dispatch('loadMe').then((me) => {
      if (me.admin || me.format_admin) {
        return store.dispatch('formats/loadAll').then(next)
      } else {
        return next();
      }
    })
  },
  async created(){

      this.getConfigFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem(configLocalStorageKey));
      }

      this.getUpdateConfigFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem(configLocalStorageKey + '_updateable'))
      }

      this.shouldUseLocalStorage = () => {
        return this.$route.params.format_id && !this.$route.params.id;
      }

      this.writeUpdateConfigToLocalStorage = (config) => {
        localStorage.setItem(configLocalStorageKey + '_updateable', JSON.stringify(config));
      }

      this.writeConfigToLocalStorage = (config) => {
        localStorage.setItem(configLocalStorageKey, JSON.stringify(config));
      }

      let formatsInterval = setInterval(async function () {
        if (this.$store.getters['formats/unfiltered'].length) {
          clearInterval(formatsInterval);

          this.format = this.$store.getters['formats/unfiltered'].filter((format) => {
            return parseInt(this.$route.params.format_id) === format.id
          })[0]

          if(!this.format && this.$store.getters.isFormatAdmin) {
            this.format = this.$store.getters['formats/allFormats'].filter((format) => {
              return parseInt(this.$route.params.format_id) === format.id
            })[0]
          }

          if (this.format) {
            FS.event('Viewing Format Builder', {
              format_id: this.format.id,
              format_name_str: this.format.name
            });
          }

          if (this.$route.params.id) {
            if (!this.ads.length && this.$route.query.share_code) {
              await this.$store.dispatch('advertisements/load');
            }
            this.ad = this.ads.filter((ad) => {
              return parseInt(this.$route.params.id) == ad.id;
            })[0];
          }

          if (!localStorage.getItem(configLocalStorageKey + '_updateable')) this.writeUpdateConfigToLocalStorage({});

          if ((this.ad && this.ad.update_rule_id) || (this.getUpdateConfigFromLocalStorage()[this.format.id] && this.getUpdateConfigFromLocalStorage()[this.format.id].isUpdateable)) {
            await this.makeUpdateable();
          }

          try {
            this.fields = JSON.parse(this.format.specification).inputs
            for (var key in this.fields) {
              var value = this.fields[key];

              var values = this.ad ? this.ad.json : {};

              if (value.type == 'object') {
                this.$set(this.settings, value.name, {});
              }

              if (values && value.name in values) {
                this.$set(this.settings, value.name, values[value.name]);
              } else if (value.default) {
                this.$set(this.settings, value.name, value.default);
              }

              this.$set(this.settings, 'name', this.ad.name ? this.ad.name : 'Untitled ' + this.format.name);

              if (this.isUpdateable) {
                this.settings['link'] = (location.origin + '/updates/' + this.$route.params.format_id + '/' + this.$route.params.id);
              }

            }
          } catch (e) {
            console.log('error parsing fields', e);
          }

          this.loadedConfigDefaults = true;

          if (!localStorage.getItem(configLocalStorageKey)) this.writeConfigToLocalStorage({});

          let update_config = this.getUpdateConfigFromLocalStorage();
          let thisUpdateConfig = null;

          if (this.isUpdateable) {
            let {format_id} = this.$route.params;

            if (format_id in update_config) {
              thisUpdateConfig = update_config[format_id];
            }

            if (thisUpdateConfig) { this.$store.commit('setUpdateRuleSettings', thisUpdateConfig) }
          }

          let config = this.getConfigFromLocalStorage();
          let thisConfig = null;

          if (this.shouldUseLocalStorage()) {
            let {format_id} = this.$route.params;

            if (format_id in config) {
              thisConfig = config[format_id];
            }

            if (thisConfig) this.$set(this, 'settings', thisConfig);
          }

        }

      }.bind(this), 100);
  },
  methods: {
    removeUpdateable (e) {
      if (e) e.preventDefault();
      this.isUpdateable = false;
      this.updateLocalStorage();
    },
    async makeUpdateable (e) {
      if (e) e.preventDefault();

      let me = this.$store.state.me;

      // if the user isn't logged in, prompt them to log in
      if (!me.id) {
        this.$modal.show('intersection');
        return;
      }

      this.isUpdateable = true;
      let data = this;
      await this.$store.dispatch('loadUpdateRuleFields').then((fields) => {
        if (!data.ad.update_rule_id) {
          fields.forEach(field => {
            data.updateable_settings[field.name] = field.default;
          })
        }
      })
      if (this.ad.update_rule_id) {
        await this.$store.dispatch('getUpdateRule', this.ad.update_rule_id);
      } else {
        await this.$store.commit('setUpdateRuleSettings', this.updateable_settings);
      }
      if (e) {
        this.updateLocalStorage();
      }
    },
    openPricingModal () {
      this.$modal.show('pricing')
    },
    openReferralModal () {
      this.$modal.show('userinput', {
        modalTitle: 'Refer a Friend to ParkAve',
        messageText: 'Enter the email of the person you want to refer to ParkAve (You will recieve an email about your watermark removal once your referral creates their first ad): ',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Refer',
        callback (value) {
          this.$modal.hide('userinput');
          store.dispatch('createReferral', {email: value});
        }
      });
    },
    configurableFields () {
      return this.fields.filter((o) => {
        return o.type !== 'size'
      })
    },
    updateLocalStorage () {
      let options = this.updateable_settings;
      options.isUpdateable = this.isUpdateable;
      let { format_id } = this.$route.params;
      let config = this.getUpdateConfigFromLocalStorage();
      config[format_id] = options;
      this.writeUpdateConfigToLocalStorage(config);
    },
    sizeItem() {
      for(var key in this.fields) {
        if (this.fields[key].type == 'size') {
          return this.fields[key];
        }
      }
      return null;
    },

    async save(e, insert){
      e.preventDefault();
      let me = this.$store.state.me;
      // if the user isn't logged in, prompt them to log in
      if (!me.id && !this.$route.query.share_code) {
        this.$modal.show('intersection');
        return;
      }

      responseNotification({}, {info: 'Creating ad...'}, {}, {timeout: 4000})

      let temp = this;
      if (this.isUpdateable) {
        let load = this.updateable_settings;
        load.timezone = window.timezone;
        if (this.ad.update_rule_id) {
          await this.$store.dispatch('updateUpdateRule', { id: this.ad.update_rule_id, payload: load });
          temp.temp_id = this.ad.update_rule_id;
        } else {
          await this.$store.dispatch('createUpdateRule', load).then((response) => {
            temp.temp_id = response.update_rule_id;
          })
        }
      } else {
        this.temp_id = null;
      }

      if (this.format.premium && !this.planChosen.allow_premium_formats && localStorage.account_id) {
        this.$modal.show('pricing')
        this.$snotify.info('This is a premium ad format! Upgrade your account to \'Pro\' or higher to gain access to it!', {timeout: 5000})
        return
      }

      let payload = {
        format_id: parseInt(this.$route.params.format_id),
        name: this.settings.name,
        json: {},
        share_code: this.getShareCode(),
        update_rule_id: this.temp_id
      };

      if (!this.settings.name || this.settings.name.length < 3) return;

      if (this.isUpdateable && this.ad.id) {
        this.$set(this.settings, 'link', (location.origin + '/updates/' + this.$route.params.format_id + '/' + this.$route.params.id))
      }

      for(var key in this.settings){
        if(key != 'name'){
          payload.json[key] = this.settings[key];
        }
      }

      let finish = ()=>{
        if(this.ad.id){
          store.dispatch('advertisements/update', {id: this.ad.id, ad: payload, callback: (response)=>{
            FS.event('Update Advertisement', {
              advertisement_id: response.id,
              advertisement_name_str: response.name,
              format_name_str: this.format.name,
              format_id: response.format_id,
              placement_id: response.placement_id
            });
            if (insert) {
              passback(response);
            }
            this.$router.push('/ads')
          }}, this.$snotify);
        } else {
          let data = this;
          store.dispatch('advertisements/create', {data: payload, callback: (response)=>{
            FS.event('Create Advertisement', {
              advertisement_id: response.id,
              advertisement_name_str: response.name,
              format_name_str: this.format.name,
              format_id: response.format_id,
              placement_id: response.placement_id
            });
            if (data.isUpdateable) {
              let load = {
                format_id: parseInt(this.$route.params.format_id),
                name: response.name,
                json: payload.json,
              };
              load.json['link'] = location.origin + '/updates/' + this.$route.params.format_id + '/' + response.id
              store.dispatch('advertisements/update', {id: response.id, ad: load });
            }
            if (insert) {
              passback(response);
            }
            if (localStorage.parkave_referral_code) {
              if (!this.account.referred_by_id) {
                store.dispatch('confirmReferral', {token: localStorage.parkave_referral_code});
              }
              delete localStorage.parkave_referral_code;
            }
            this.$router.push('/ads')
          }});
        }

        let update_config = this.getUpdateConfigFromLocalStorage();
        let { format_id } = this.$route.params;

        if(this.shouldUseLocalStorage()){
          if(format_id in update_config){
            let newConfig = _.omit(update_config, [format_id]);

            this.writeUpdateConfigToLocalStorage(newConfig);
          }
        }

        let config = this.getConfigFromLocalStorage();

        if(this.shouldUseLocalStorage()){
          if(format_id in config){
            let newConfig = _.omit(config, [format_id]);

            this.writeConfigToLocalStorage(newConfig);
          }
        }
      }

      if(!me.id && !payload.share_code) {
        window.scrollTo(0, 0);
        window.afterCompleteSignUpModal = ()=>{
          finish();
          this.$modal.hide('intersection');
          store.dispatch('accounts/update', {plan: 'free', skipSuccessMessage: true});
        }

        this.$modal.show('intersection')
        //this.$modal.show('sign-up');
      } else {
        finish();
      }
    },
    getFormName(type, index){
      return `${type}-${index}`
    },
    onChangeTime(binding, newVal){
      let { HH, mm, ss } = newVal.data;
      this.settings[binding] = { HH, mm, ss }
    },
    onPreviewData(preview) {
      if (preview.scale) {
        this.$set(this.preview, 'scale', preview.scale);
      }
    },
  },
  watch: {
    sidebarActive: {
      handler(){
        this.$refs.preview.generatePreview()
      }
    },
    settings: {
      deep: true,
      handler(newVal){
        let config = this.getConfigFromLocalStorage();

        if(this.shouldUseLocalStorage() && this.loadedConfigDefaults){
          let { format_id } = this.$route.params;
          config[format_id] = newVal;
          this.writeConfigToLocalStorage(config);
        }
      }
    }
  },
  data () {
    return {
      sidebarActive: true,
      format: {},
      fields: [],
      settings: {},
      ad: {},
      meta: {},
      preview: {
        srcdoc: '',
        length: 0,
        scale: 100
      },
      temp_id: null,
      isUpdateable: false
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$store.state.me.errors !== 'unauthorized') {
        let configTour = this.$store.state.preferences['ad_creation_tour'];
        if (!configTour || configTour !== 'finished') {
          //this.$tours['config_tour'].start();
        }
      }

      // If user is logged in, but is not a admin or format_admin and there is no format
      if ((!this.$store.state.me.admin || !this.$store.state.me.format_admin) && !this.format) {
        this.$router.push('/')
      }
    }, 500)
  },
  beforeDestroy () {
    if (this.$tours['config_tour'].isRunning) {
      this.$tours['config_tour'].stop();
    }
  },
  computed: {
    ...mapState(['planChosen', 'account']),
    ...mapState('advertisements', ['ads']),
    ...mapState(['updateable_fields', 'updateable_settings']),
    hideWatermark () {
      if (this.format.updateable) {
        return this.account.hide_selfserve_watermark || this.planChosen.short_name != 'free'
      } else {
        return this.planChosen.short_name != 'free';
      }
    },
    approvalEmail () {
      return this.updateable_settings.approval_email;
    },
    getSelfServeLink () {
      let link = location.origin + '/updates/' + this.$route.params.format_id + '/' + this.$route.params.id
      return link
    },
 }
}
</script>

<style scoped>
  .button--primary {
    color: white !important;
  }

  .update__button--remove {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue